import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { IDS } from '../../automationTestIds';
import { triggerLifeCycleEvent } from '../helper/utils';

const getDeliveryHost = () => {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return 'https://www.homedepot.com';
  }

  return window.location.origin.match(/local/g)
    ? 'https://www.homedepot.com'
    : window.location.origin;
};

const isMyCartHomePage = () => (
  typeof window !== 'undefined' && window.location?.href?.includes('/mycart/home')
);

export const DeliveryHeader = ({
  itemId,
  quantity = 0,
  zipCode,
  showCheckAvailability,
  setShowCheckAvailability,
  isCartTiles = false,
  lineItemId = '',
  fulfillmentMethod,
  applianceCountInCart = 0,
  channel,
  isMajorAppliance,
  openApplianceCheckAvailability,
  showZipCodeDrawer = false,
}) => {
  const { isConsumerApp } = useContext(ExperienceContext);

  const getCartReqParams = () => ({
    itemId,
    lineItemId,
    zipCode,
    host: getDeliveryHost(),
    enableNucleusDrawer: true,
    fulfillmentMethod,
    digitalDataFlag: true
  });

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isConsumerApp) {
      return setShowCheckAvailability(!showCheckAvailability);
    }
    triggerLifeCycleEvent('open_delivery_zip_menu');
  };

  const openCheckAvailability = () => {
    if (isMyCartHomePage()) {
      openApplianceCheckAvailability({ lineItemId, shippingType: fulfillmentMethod, channel });
    } else {
      triggerLifeCycleEvent('cart.check-availability', {
        cartReqParams: getCartReqParams()
      });
    }
  };

  const openZipDrawer = (event) => {
    event.preventDefault();
    event.stopPropagation();
    triggerLifeCycleEvent(
      'cart.zip-code-update-click',
      {
        applianceDeliveryItems: [{
          itemId,
          quantity,
          selectedFulfillment: fulfillmentMethod,
          lineItemId,
        }],
        skipLocalization: true
      }
    );
  };

  const availabilityStencilButton = (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      component="span"
      onClick={handleOnClick}
      data-testid="delivery-header-zipcode-link"
    >
      { zipCode }
    </Link>
  );

  const appZipCodeButton = (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      component="span"
      color="primary"
      onClick={showZipCodeDrawer ? openZipDrawer : openCheckAvailability}
      data-testid="delivery-header-zipcode-link"
    >
      { zipCode }
    </Link>
  );

  const applZipCode = (applianceCountInCart === 1) ? appZipCodeButton : zipCode;

  return (
    <div
      className="sui-flex sui-w-1/2 sui-pl-2 sui-mt-auto"
      data-automation-id={IDS.LABEL.deliveryToLabel}
    >
      <Typography variant="body-base" height="normal">
        {'Delivering to '}
        <span className="sui-cursor-pointer">{ isCartTiles
          && isMajorAppliance ? applZipCode : availabilityStencilButton }
        </span>
      </Typography>
    </div>
  );
};

DeliveryHeader.propTypes = {
  itemId: PropTypes.string.isRequired,
  showZipCodeDrawer: PropTypes.bool,
  lineItemId: PropTypes.string,
  zipCode: PropTypes.string.isRequired,
  showCheckAvailability: PropTypes.bool.isRequired,
  setShowCheckAvailability: PropTypes.func.isRequired,
  isCartTiles: PropTypes.bool,
  applianceCountInCart: PropTypes.number,
  channel: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  fulfillmentMethod: PropTypes.string.isRequired,
  isMajorAppliance: PropTypes.bool.isRequired,
  openApplianceCheckAvailability: PropTypes.func.isRequired
};
